// Load Fund List
export const START_LOAD_FUND_LIST = 'START_LOAD_FUND_LIST';
export const LOAD_FUND_LIST_SUCCESS = 'LOAD_FUND_LIST_SUCCESS';
export const LOAD_FUND_LIST_FAILURE = 'LOAD_FUND_LIST_FAILURE';
export const INIT_LOAD_FUND_LIST_ACTION_STATUS = 'INIT_LOAD_FUND_LIST_ACTION_STATUS';